<template lang="pug">
#plan_custom
  plan-interval-menu(:is_new_ui="is_new_ui" :interval="interval", :interval_count="interval_count")

  .row.mt-5
    .col-sm-4
      .form-group
        label(for="monthlyHeatmapImpLimit") 月間PV上限数を入力してください。
        input#monthlyHeatmapImpLimit.form-control.form-control-lg.rounded-0(placeholder="4000000", type="number", v-model="monthly_heatmap_imp_limit", min="4000000", @input="checkHeatmapNumber", :class="{ 'is-invalid': imp_heatmap_min_error }")
        .invalid-feedback(v-if="imp_heatmap_min_error") 4,000,000以上の数字を入力してください
        p.text-sm.text-muted.mb-0 ※400万PVが下限となります。
        p.text-sm.text-muted ※ポップアップのPV上限数はヒートマップと同じ値になります。
    .col-sm-8
      label プラン詳細
      table.table.table-borderless.mb-0
        tbody
          tr
            th ヒートマップ月間PV
            td
              .big_num {{ parseInt(this.monthly_heatmap_imp_limit).toLocaleString('ja-JP') }}
          tr
            th ポップアップ月間PV
            td
              .big_num {{ parseInt(this.monthly_imp_limit).toLocaleString('ja-JP') }}
          tr
            th 月額料金
            td
              .big_num.price {{$store.state.custom_plan.amount.toLocaleString('ja-JP')}} 円
          tr
            td.text-sm.text-muted ※利用できる機能は最上位プラン(Enterprise)と同一となります。
            td
              button.btn.btn-primary(v-if="canCreateCustomPlan" @click="createCustomPlan") カスタムプラン作成
</template>

<script>
import Vue from 'vue';

import StrMixin from '../mixins/str';

import PlanIntervalMenu from '../components/plan_interval_menu.vue';

export default {
  props: {
    plan_interval_name: {type: String, default: "month"},
    current_plan_name: { type: String, default: "free" },
    current_plan_id: { type: String, default: null },
    interval: { type: String, default: "month" },
    interval_count: { type: String, default: "1" },
    is_new_ui: { type: Boolean, default: false},
  },
  data(){
    return {
      imp_min_error: false,
      imp_heatmap_min_error: false,
      monthly_heatmap_imp_limit: 4_000_000,
      monthly_imp_limit: 4_000_000,
    }
  },
  components: {
    PlanIntervalMenu
  },
  methods: {
    checkHeatmapNumber(e){
      const number = e.target.value
      /* ポップアップのPV上限をヒートマップと同じ値に設定 */
      this.monthly_imp_limit = number
      if(number < 4_000_000){
        this.$store.commit("custom_plan/setMontlyImpLimit", 4_000_000)
        this.$store.commit("custom_plan/setHeatmapImpLimit", 4_000_000)
        this.$store.commit("custom_plan/setAmount", this.price)
        this.imp_heatmap_min_error = true
      } else {
        this.$store.commit("custom_plan/setMontlyImpLimit", number)
        this.$store.commit("custom_plan/setHeatmapImpLimit", number)
        this.$store.commit("custom_plan/setAmount", this.price)
        this.imp_heatmap_min_error = false
      }
    },
    async createCustomPlan(e){
      e.preventDefault()
      if(this.$store.state.user.is_anual){
        var interval = "year"
      } else {
        var interval = "month"
      }
      let r = await  this.$store.dispatch("custom_plan/create",{
        interval: interval,
        interval_count: this.$store.state.user.interval_count,
        monthly_imp_limit: this.monthly_imp_limit,
        monthly_heatmap_imp_limit: this.monthly_heatmap_imp_limit
      })
      this.$store.commit("custom_plan/addList", r.data)
      this.$toasted.success('カスタムプランを作成しました。一覧右の「操作」から変更してください。')
      window.scrollTo(0, 0);
    },
  },
  mixins:[StrMixin],
  watch: {
  },
  computed: {
    canCreateCustomPlan(){
      return parseInt(this.monthly_heatmap_imp_limit) >= 4_000_000
    },
    plan_name(){
      return this.$store.state.user.plan_name
    },
    plan_span_name(){
      if (this.interval == "year"){
        return "1年間プラン"
      } else {
        return this.interval_count+"ヶ月払いプラン"
      }
    },
    price(){
      const pv = parseInt(this.monthly_imp_limit)
      let unitPrice = 0

      if (this.is_new_ui) {
        // 新UIの場合: 月払い、年払い、3年払い
        if (pv <= 2_000_000) {
          // 50万PV～200万PV
          if (this.$store.state.user.interval_count == 36) {
            unitPrice = 0.013  // 3年払い
          } else if (this.$store.state.user.is_anual) {
            unitPrice = 0.019  // 1年払い
          } else {
            unitPrice = 0.026  // 1ヶ月払い
          }
        } else {
          // 200万1PV〜
          if (this.$store.state.user.interval_count == 36) {
            unitPrice = 0.010  // 3年払い
          } else if (this.$store.state.user.is_anual) {
            unitPrice = 0.011  // 1年払い
          } else {
            unitPrice = 0.018  // 1ヶ月払い
          }
        }
      } else {
        // 旧UIの場合: 1ヶ月、3ヶ月、6ヶ月、12ヶ月（年払い）
        const intervalCount = this.$store.state.user.interval_count
        if (pv <= 2_000_000) {
          // 50万PV～200万PV
          if (this.$store.state.user.is_anual) {
            unitPrice = 0.019  // 12ヶ月（年払い）
          } else if (intervalCount == 6) {
            unitPrice = 0.021  // 6ヶ月払い
          } else if (intervalCount == 3) {
            unitPrice = 0.023  // 3ヶ月払い
          } else {
            unitPrice = 0.026  // 1ヶ月払い
          }
        } else {
          // 200万1PV〜
          if (this.$store.state.user.is_anual) {
            unitPrice = 0.011  // 12ヶ月（年払い）
          } else if (intervalCount == 6) {
            unitPrice = 0.012  // 6ヶ月払い
          } else if (intervalCount == 3) {
            unitPrice = 0.014  // 3ヶ月払い
          } else {
            unitPrice = 0.018  // 1ヶ月払い
          }
        }
      }

      return Math.floor(pv * unitPrice)
    }
  },
  watch: {
    'price': function (val) {
      this.$store.commit("custom_plan/setAmount", this.price)
    }
  },
  async mounted(){
    await Vue.nextTick()
    this.$store.commit("user/setPlanId", this.current_plan_id)
    this.$store.commit("user/setPlanIntervalName", this.plan_interval_name)
    this.$store.commit("user/setPlanName", this.current_plan_name)
    // 初回マウント時に価格を計算してストアに反映
    this.$store.commit("custom_plan/setAmount", this.price)
  },
}
</script>
<style lang="scss" scoped>
.callout{
  a{
    color:white;
    text-decoration:none;
  }
}
table{
  th.head_title{
    background: #f1f1f1;
    padding:0.5rem 0.75rem;
  }
  strong{
    font-size: 1.5em
  }
}
.empty{
  border: none;
  background: #ffff;
}
.border-cell {
    border: 1px solid #dee2e6; /* 好みに応じてボーダーのスタイルを調整 */
}
</style>
